export default __webpack_public_path__ + "static/media/meal.c7f2c3ff.svg";